import { Component, OnDestroy, OnInit } from '@angular/core';
import { TokenService } from '@kitch/data-access/services';
import { SeoService } from '@kitch/ui/services';

@Component({
  selector: 'app-favorites-outlet',
  templateUrl: './favorites-outlet.component.html',
  styleUrls: ['../favorites-shared.scss'],
})
export class FavoritesOutletComponent implements OnInit, OnDestroy {
  isGuest: boolean;

  constructor(
    private tokenService: TokenService,
    private seoService: SeoService,
  ) { }

  ngOnInit(): void {
    this.isGuest = this.tokenService.isGuest();
    this.seoService.setNoIndexMetaTag();
  }

  ngOnDestroy() {
    this.seoService.removeNoIndexMetaTag();
  }
}
